import { render, staticRenderFns } from "./analysis_types.vue?vue&type=template&id=70d304ce&scoped=true&"
import script from "./analysis_types.vue?vue&type=script&lang=js&"
export * from "./analysis_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d304ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d304ce')) {
      api.createRecord('70d304ce', component.options)
    } else {
      api.reload('70d304ce', component.options)
    }
    module.hot.accept("./analysis_types.vue?vue&type=template&id=70d304ce&scoped=true&", function () {
      api.rerender('70d304ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/analysis_types.vue"
export default component.exports